import { Trash2 } from "lucide-react";
import { useEffect, useState } from "react";

import type { LanguageItem as LanguageItemData } from "@/app/types/resume";

import AutoSuggestion from "../../../../../components/AutoSuggestion";
import ProficiencyRange from "./ProficiencyRange";

interface LanguageItemProps {
	languages: string[];
	index: number;
	updateLanguagesData: (index: number, data: { language: string; proficiency: string }) => void;
	item: LanguageItemData;
	deleteLanguage: (index: number) => void;
	error?: string;
}

function LanguageItem({ languages, index, updateLanguagesData, item, deleteLanguage, error }: LanguageItemProps) {
	const [language, setLanguage] = useState("");
	const [proficiency, setProficiency] = useState("");

	const onSetProficiency = (level: string) => {
		setProficiency(level);
	};

	useEffect(() => {
		setLanguage(item.language);
		setProficiency(item.proficiency);
	}, [item]);

	useEffect(() => {
		updateLanguagesData(index, { language, proficiency });
	}, [language, proficiency]);

	return (
		<div className="mb-6">
			<div className="mb-3 flex items-start gap-2">
				<div className="relative grow">
					<AutoSuggestion
						suggestions={languages}
						label="Type language"
						type="text"
						name="newSelectedLanguage"
						userInput={language}
						setUserInput={setLanguage}
						isForm={true}
					/>
				</div>
				{languages.length > 0 && (
					<button
						type="button"
						onClick={() => deleteLanguage(index)}
						className="mt-8 cursor-pointer text-error-default hover:text-error-dark"
						aria-label="Delete language"
					>
						<Trash2 className="size-4" />
					</button>
				)}
			</div>
			<ProficiencyRange setLevel={onSetProficiency} value={proficiency} />
			{error && <p className="mt-1 text-error-default text-sm">{error}</p>}
		</div>
	);
}

export default LanguageItem;
